import { ErrorView } from "@/components/ui/layout/error/errorView"
import {
  BoxProgramFormView,
  type BoxProgramFormViewRef,
} from "@/modules/boxProgrammation/components/boxProgramFormView"
import { BoxProgramInfoResume } from "@/modules/boxProgrammation/components/boxProgramInfoResume"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { Suspense, useRef } from "react"
import { ErrorBoundary } from "react-error-boundary"

export const useBoxProgrammationSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()
  const boxProgramFormViewRef = useRef<BoxProgramFormViewRef>(null)
  const canManageActivity = useBoxStaffPermission(BoxStaffPermissions.CREATE_ACTIVITY)

  const navigateToProgrammationView = (boxProgramId: string) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxProgramInfoResume boxProgramId={boxProgramId} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })
  }

  const navigateToBoxProgrammationCreation = () => {
    // PERMISSIONS -Coach & Financial permissions denied
    if (!canManageActivity) {
      return null
    }

    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxProgramFormView ref={boxProgramFormViewRef} />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => {
        return boxProgramFormViewRef.current ? boxProgramFormViewRef.current.onClose() : Promise.resolve(true)
      },
    })
  }

  const navigateToProgrammationEdition = (boxProgramId: string) => {
    // PERMISSIONS -Coach & Financial permissions denied
    if (!canManageActivity) {
      return null
    }

    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxProgramFormView ref={boxProgramFormViewRef} boxProgramId={boxProgramId} />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => {
        return boxProgramFormViewRef.current ? boxProgramFormViewRef.current.onClose() : Promise.resolve(true)
      },
    })
  }

  return {
    navigateToProgrammationView,
    navigateToBoxProgrammationCreation,
    navigateToProgrammationEdition,
  }
}
